/**
 * Typed accessors for the synced app UI defaults JSON.
 * Edit shared/app-ui-defaults.json then run: node scripts/sync-app-ui-defaults.cjs
 */
import defaults from './app-ui-defaults.json';

export type AppUiTableDefaults = {
  defaultPageSize: number;
  pageSizeOptions: number[];
  defaultDensity: 'compact' | 'normal' | 'comfortable';
};

export type AppUiDashboardDefaults = {
  gridColumns: number;
  statCardWidth: number;
  listWidgetWidth: number;
  chartWidth: number;
  fullWidth: number;
};

export type AppUiNavigationDefaults = {
  sidebarStyle: 'classic' | 'rail' | 'tabs' | 'workspaces' | 'topmenu' | 'sidebar_topmenu';
};

export type AppUiUserDefaults = {
  bookmarksDisplayMode: 'dropdown' | 'bar' | 'pins' | 'sidebar' | 'none';
};

export type AppUiDefaults = {
  table: AppUiTableDefaults;
  dashboard: AppUiDashboardDefaults;
  navigation: AppUiNavigationDefaults;
  userDefaults: AppUiUserDefaults;
};

export const APP_UI_DEFAULTS = defaults as AppUiDefaults;
